import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function PercentagesPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        Procent opisuje część całości. Zapis <InlineMath math="p\%" /> oznacza
        <InlineMath math={String.raw`\frac{p}{100}`} /> całości, dlatego
      </p>
      <BlockMath math={String.raw`p\%\text{ liczby }a=\frac{p}{100}\cdot a`} />
      <p>
        Aby sprawdzić, jaki procent liczby <InlineMath math="B" /> stanowi liczba
        <InlineMath math="A" />, dzielimy część przez całość:
      </p>
      <BlockMath math={String.raw`p=\frac{A}{B}\cdot100\%`} />
      <p>
        Przy <strong>procencie prostym</strong> w każdym okresie naliczamy odsetki
        od tej samej wartości początkowej. Dla kapitału <InlineMath math="K_0" />,
        stopy <InlineMath math="p\%" /> i <InlineMath math="n" /> okresów:
      </p>
      <BlockMath math={String.raw`K_n=K_0\left(1+n\cdot\frac{p}{100}\right)`} />
      <p>
        Przy <strong>procencie składanym</strong> odsetki są dopisywane do kapitału,
        więc w kolejnym okresie procent naliczamy już od większej wartości:
      </p>
      <BlockMath math={String.raw`K_n=K_0\left(1+\frac{p}{100}\right)^n`} />
      <p>
        Gdy pytanie dotyczy samych odsetek, od kapitału końcowego odejmujemy wpłatę:
      </p>
      <BlockMath math={String.raw`\text{odsetki}=K_n-K_0`} />
    </div>
  );

  const examples = [
  {
      label: "Przykład 1",
      summary: "Procent danej liczby",
      description: (
        <span>
          W klasie jest <InlineMath math="30" /> uczniów. Na konkurs pojechało
          <InlineMath math="20\%" /> klasy. Ilu uczniów pojechało na konkurs?
        </span>
      ),
      content: <BlockMath math={String.raw`20\%\text{ z }30=\frac{20}{100}\cdot30=6`} />,
    },
    {
      label: "Przykład 2",
      summary: "Porównanie procentowe",
      description: (
        <span>
          Plecak kosztował <InlineMath math="80\text{ zł}" />, a po zmianie ceny
          kosztuje <InlineMath math="100\text{ zł}" />. O ile procent nowa cena
          jest wyższa od starej?
        </span>
      ),
      content: <BlockMath math={String.raw`\frac{100-80}{80}\cdot100\%=25\%`} />,
    },
    {
      label: "Przykład 3",
      summary: "Procent prosty",
      description: (
        <span>
          Kapitał <InlineMath math="K_0=10000\text{ zł}" /> ulokowano na
          <InlineMath math="2" /> lata przy oprocentowaniu <InlineMath math="6\%" />
          rocznie. Odsetki nie są kapitalizowane.
        </span>
      ),
      content: (
        <div>
          <BlockMath math={String.raw`K_2=10000\left(1+2\cdot\frac{6}{100}\right)=11200\text{ zł}`} />
          <BlockMath math={String.raw`\text{odsetki}=11200-10000=1200\text{ zł}`} />
        </div>
      ),
    },
    {
      label: "Przykład 4",
      summary: "Procent składany",
      description: (
        <span>
          Ten sam kapitał <InlineMath math="K_0=10000\text{ zł}" /> ulokowano na
          <InlineMath math="2" /> lata przy oprocentowaniu <InlineMath math="6\%" />
          rocznie, tym razem z coroczną kapitalizacją odsetek.
        </span>
      ),
      content: (
        <div>
          <BlockMath math={String.raw`K_2=10000\cdot1{,}06^2=11236\text{ zł}`} />
          <BlockMath math={String.raw`\text{odsetki}=11236-10000=1236\text{ zł}`} />
        </div>
      ),
    },

{label:'Uzupełnienie. Właściwa podstawa porównania',summary:'Wynik może być większy niż 100%',content:(<><p>Jaki procent liczby 16 stanowi liczba 20?</p><BlockMath math={String.raw`\frac{20}{16}\cdot100\%=125\%`} /><p>To inne pytanie niż „o ile procent 20 jest większe od 16”, gdzie wynik wynosi 25%. W mianowniku zawsze stoi wielkość, do której porównujemy; musi być niezerowa.</p></>)},
{label:'Uzupełnienie. Kwota początkowa',summary:'Cofamy dwie kapitalizacje',content:(<><p>Po dwóch latach przy 10% rocznie na lokacie jest 12100 zł.</p><BlockMath math={String.raw`K_0\cdot1{,}1^2=12100\quad\Rightarrow\quad K_0=\frac{12100}{1{,}21}=10000\text{ zł}`} /></>)},
{label:'Uzupełnienie. Roczne oprocentowanie',summary:'Nie dzielimy całego wzrostu przez liczbę lat',content:(<><p>Kapitał 10000 zł wzrósł po dwóch latach do 12100 zł przy stałej stopie rocznej.</p><BlockMath math={String.raw`\left(1+\frac p{100}\right)^2=\frac{12100}{10000}=1{,}21`} /><BlockMath math={String.raw`1+\frac p{100}=1{,}1\quad\Rightarrow\quad p=10`} /><p>Wybieramy dodatni mnożnik kapitału. Łączny wzrost wynosi 21%, ale roczne oprocentowanie wynosi 10%, nie 10,5%.</p></>)},

  
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
